import AspectRatio from './aspect-ratio';

export default AspectRatio;
export type * from './types';
